<template>
  <ButtonCard
    class="button"
    theme="primary"
    aspect="14-9"
    stroke="n"
    size="medium"
    :selected="selected"
    appear-effect="fade-in"
    @click.capture="handleClick"
  >
    <span class="name">{{ name }}</span>
  </ButtonCard>
</template>
<script lang="ts" setup>
interface Props {
  name: string;
  value: string;
  selected: boolean;
}
const props = defineProps({
  name: null,
  value: null,
  selected: { type: Boolean }
});
const emit = defineEmits(["select"]);

const { $colors } = useNuxtApp();

const colorIcon = computed(() => {
  return $colors.primary;
});

const handleClick = (e) => {
  emit('select', props.value);
};

const csscolor = computed(() => colorIcon.value);
</script>
<style lang="scss" scoped>
.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.name {
  transition: color 400ms $ease-in-quad;
}
.button {
  transition: border 300ms $ease-out-quad, box-shadow 300ms $ease-in-quad;
  border: var(--stroke_thickness_l) solid var(--color_neutral_50);
  box-shadow: rgb(0 0 0 / 10%) 0 1px 3px 0, rgb(0 0 0 / 6%) 0 1px 2px 0;
  &:focus,
  &:hover {
    transition: border 200ms $ease-out-quad, box-shadow 200ms $ease-out-quad;
    box-shadow: rgb(255 106 14 / 80%) 0 1px 3px 0,
      rgb(255 106 14 / 48%) 0 1px 2px 0;
    .title {
      color: v-bind(csscolor);
    }
  }
  &.selected {
    border: var(--stroke_thickness_l) solid var(--color_primary);
    box-shadow: rgb(0 0 0 / 10%) 0 1px 3px 0, rgb(0 0 0 / 6%) 0 1px 2px 0;
  }
}
</style>
